import { __extends, __values } from 'tslib';
import { Level, AjaxAppender, JsonLayout, Appender, logLog, getRootLogger, BrowserConsoleAppender, PatternLayout, getLogger } from 'log4javascript';
import { EventEmitter, Injectable, NgModule, defineInjectable } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
var LogLevel = {
    /**
     * All events should be logged.
     */
    ALL: 0,
    /**
     * A fine-grained debug message, typically capturing the flow through the application.
     */
    TRACE: 1,
    /**
     * A general debugging event.
     */
    DEBUG: 2,
    /**
     * An event for informational purposes.
     */
    INFO: 3,
    /**
     * An event that might possible lead to an error.
     */
    WARN: 4,
    /**
     * An error in the application, possibly recoverable.
     */
    ERROR: 5,
    /**
     * A severe error that will prevent the application from continuing.
     */
    FATAL: 6,
    /**
     * No events will be logged.
     */
    OFF: 7,
};
LogLevel[LogLevel.ALL] = 'ALL';
LogLevel[LogLevel.TRACE] = 'TRACE';
LogLevel[LogLevel.DEBUG] = 'DEBUG';
LogLevel[LogLevel.INFO] = 'INFO';
LogLevel[LogLevel.WARN] = 'WARN';
LogLevel[LogLevel.ERROR] = 'ERROR';
LogLevel[LogLevel.FATAL] = 'FATAL';
LogLevel[LogLevel.OFF] = 'OFF';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Helper class for converting log levels from and to different data type.
 */
var  /**
 * Helper class for converting log levels from and to different data type.
 */
LogLevelConverter = /** @class */ (function () {
    function LogLevelConverter() {
    }
    /**
     * Converts log4javascript.Level to internal LogLevel.
     * @param level log4javascript's data type
     * @return internal data type.
     */
    /**
     * Converts log4javascript.Level to internal LogLevel.
     * @param {?} level log4javascript's data type
     * @return {?} internal data type.
     */
    LogLevelConverter.levelFromLog4Javascript = /**
     * Converts log4javascript.Level to internal LogLevel.
     * @param {?} level log4javascript's data type
     * @return {?} internal data type.
     */
    function (level) {
        switch (level) {
            case Level.ALL:
                return LogLevel.ALL;
            case Level.DEBUG:
                return LogLevel.DEBUG;
            case Level.ERROR:
                return LogLevel.ERROR;
            case Level.FATAL:
                return LogLevel.FATAL;
            case Level.INFO:
                return LogLevel.INFO;
            case Level.OFF:
                return LogLevel.OFF;
            case Level.TRACE:
                return LogLevel.TRACE;
            case Level.WARN:
                return LogLevel.WARN;
            default:
                throw new Error("invalid level " + level);
        }
    };
    /**
     * Converts string representation to internal LogLevel.
     * @param level string representation
     * @return internal data type.
     */
    /**
     * Converts string representation to internal LogLevel.
     * @param {?} level string representation
     * @return {?} internal data type.
     */
    LogLevelConverter.levelFromString = /**
     * Converts string representation to internal LogLevel.
     * @param {?} level string representation
     * @return {?} internal data type.
     */
    function (level) {
        switch (level) {
            case "ALL":
                return LogLevel.ALL;
            case "DEBUG":
                return LogLevel.DEBUG;
            case "ERROR":
                return LogLevel.ERROR;
            case "FATAL":
                return LogLevel.FATAL;
            case "INFO":
                return LogLevel.INFO;
            case "OFF":
                return LogLevel.OFF;
            case "TRACE":
                return LogLevel.TRACE;
            case "WARN":
                return LogLevel.WARN;
            default:
                throw new Error("invalid level " + level);
        }
    };
    /**
     * Converts internal LogLevel to log4javascript.Level.
     * @param internal data type.
     * @return level log4javascript's data type
     */
    /**
     * Converts internal LogLevel to log4javascript.Level.
     * @param {?} level
     * @return {?} level log4javascript's data type
     */
    LogLevelConverter.levelToLog4Javascript = /**
     * Converts internal LogLevel to log4javascript.Level.
     * @param {?} level
     * @return {?} level log4javascript's data type
     */
    function (level) {
        switch (level) {
            case LogLevel.ALL:
                return Level.ALL;
            case LogLevel.DEBUG:
                return Level.DEBUG;
            case LogLevel.ERROR:
                return Level.ERROR;
            case LogLevel.FATAL:
                return Level.FATAL;
            case LogLevel.INFO:
                return Level.INFO;
            case LogLevel.OFF:
                return Level.OFF;
            case LogLevel.TRACE:
                return Level.TRACE;
            case LogLevel.WARN:
                return Level.WARN;
            default:
                throw new Error("invalid level " + level);
        }
    };
    return LogLevelConverter;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * An appender which sends the log messages to a server via HTTP.
 *
 * A typical configuration could be:
 *
 * ```json
 * {
 *   "url": "https://my.backend.xy/LoggingBackend",
 *   "batchSize": 10,
 *   "timerInterval": 60000,
 *   "threshold": "INFO"
 * }
 * ```
 */
var AjaxAppender$1 = /** @class */ (function (_super) {
    __extends(AjaxAppender$$1, _super);
    /**
     * Creates a new instance of the appender.
     * @param configuration configuration for the appender.
     */
    function AjaxAppender$$1(configuration) {
        var _this = _super.call(this) || this;
        if (!configuration) {
            throw new Error("configuration must be not empty");
        }
        if (!configuration.url) {
            throw new Error("url must be not empty");
        }
        _this.ajaxAppender = new AjaxAppender(configuration.url);
        _this.url = configuration.url;
        _this.ajaxAppender.setLayout(new JsonLayout(false, false));
        _this.ajaxAppender.addHeader("Content-Type", "application/json; charset=utf-8");
        _this.ajaxAppender.setSendAllOnUnload(true);
        _this.appenderFailed = new EventEmitter();
        _this.ajaxAppender.setFailCallback(function (message) {
            _this.appenderFailed.emit(message);
        });
        // process remaining configuration
        _this.configure({
            batchSize: configuration.batchSize || AjaxAppender$$1.batchSizeDefault,
            threshold: configuration.threshold || AjaxAppender$$1.thresholdDefault,
            timerInterval: configuration.timerInterval || AjaxAppender$$1.timerIntervalDefault,
            url: configuration.url,
        });
        return _this;
    }
    /**
     * Configures the logging depending on the given configuration.
     *
     * Only the defined properties get overwritten.
     * The url cannot be modified.
     *
     * @param configuration configuration data.
     */
    /**
     * Configures the logging depending on the given configuration.
     *
     * Only the defined properties get overwritten.
     * The url cannot be modified.
     *
     * @param {?} configuration configuration data.
     * @return {?}
     */
    AjaxAppender$$1.prototype.configure = /**
     * Configures the logging depending on the given configuration.
     *
     * Only the defined properties get overwritten.
     * The url cannot be modified.
     *
     * @param {?} configuration configuration data.
     * @return {?}
     */
    function (configuration) {
        if (configuration) {
            if (configuration.url && configuration.url !== this.url) {
                throw new Error("url must not be changed");
            }
            if (configuration.batchSize) {
                this.setBatchSize(configuration.batchSize);
            }
            if (typeof configuration.timerInterval === "number") {
                this.setTimerInterval(configuration.timerInterval);
            }
            if (configuration.threshold) {
                /** @type {?} */
                var convertedThreshold = LogLevelConverter.levelToLog4Javascript(LogLevelConverter.levelFromString(configuration.threshold));
                this.setThreshold(convertedThreshold);
            }
        }
    };
    /**
     * Appender-specific method to append a log message.
     * @param loggingEvent event to be appended.
     */
    /**
     * Appender-specific method to append a log message.
     * @param {?} loggingEvent event to be appended.
     * @return {?}
     */
    AjaxAppender$$1.prototype.append = /**
     * Appender-specific method to append a log message.
     * @param {?} loggingEvent event to be appended.
     * @return {?}
     */
    function (loggingEvent) {
        this.ajaxAppender.append(loggingEvent);
    };
    /**
     * Gets the appender's name.
     * Mainly for unit testing purposes.
     * @return appender's name
     */
    /**
     * Gets the appender's name.
     * Mainly for unit testing purposes.
     * @return {?} appender's name
     */
    AjaxAppender$$1.prototype.toString = /**
     * Gets the appender's name.
     * Mainly for unit testing purposes.
     * @return {?} appender's name
     */
    function () {
        return "Ionic.Logging.AjaxAppender";
    };
    /**
     * Get the internally used appender.
     * Mainly for unit testing purposes.
     */
    /**
     * Get the internally used appender.
     * Mainly for unit testing purposes.
     * @return {?}
     */
    AjaxAppender$$1.prototype.getInternalAppender = /**
     * Get the internally used appender.
     * Mainly for unit testing purposes.
     * @return {?}
     */
    function () {
        return this.ajaxAppender;
    };
    /**
     * Returns the number of log messages sent in each request.
     */
    /**
     * Returns the number of log messages sent in each request.
     * @return {?}
     */
    AjaxAppender$$1.prototype.getBatchSize = /**
     * Returns the number of log messages sent in each request.
     * @return {?}
     */
    function () {
        return this.ajaxAppender.getBatchSize();
    };
    /**
     * Sets the number of log messages to send in each request.
     * @param batchSize new batch size
     */
    /**
     * Sets the number of log messages to send in each request.
     * @param {?} batchSize new batch size
     * @return {?}
     */
    AjaxAppender$$1.prototype.setBatchSize = /**
     * Sets the number of log messages to send in each request.
     * @param {?} batchSize new batch size
     * @return {?}
     */
    function (batchSize) {
        this.ajaxAppender.setBatchSize(batchSize);
    };
    /**
     * Returns the appender's layout.
     */
    /**
     * Returns the appender's layout.
     * @return {?}
     */
    AjaxAppender$$1.prototype.getLayout = /**
     * Returns the appender's layout.
     * @return {?}
     */
    function () {
        return this.ajaxAppender.getLayout();
    };
    /**
     * Sets the appender's layout.
     */
    /**
     * Sets the appender's layout.
     * @param {?} layout
     * @return {?}
     */
    AjaxAppender$$1.prototype.setLayout = /**
     * Sets the appender's layout.
     * @param {?} layout
     * @return {?}
     */
    function (layout) {
        this.ajaxAppender.setLayout(layout);
    };
    /**
     * Returns the length of time in milliseconds between each sending of queued log messages.
     */
    /**
     * Returns the length of time in milliseconds between each sending of queued log messages.
     * @return {?}
     */
    AjaxAppender$$1.prototype.getTimerInterval = /**
     * Returns the length of time in milliseconds between each sending of queued log messages.
     * @return {?}
     */
    function () {
        return this.ajaxAppender.getTimerInterval();
    };
    /**
     * Sets the length of time in milliseconds between each sending of queued log messages.
     * @param timerInterval new timer interval
     */
    /**
     * Sets the length of time in milliseconds between each sending of queued log messages.
     * @param {?} timerInterval new timer interval
     * @return {?}
     */
    AjaxAppender$$1.prototype.setTimerInterval = /**
     * Sets the length of time in milliseconds between each sending of queued log messages.
     * @param {?} timerInterval new timer interval
     * @return {?}
     */
    function (timerInterval) {
        this.ajaxAppender.setTimed(timerInterval > 0);
        this.ajaxAppender.setTimerInterval(timerInterval);
    };
    AjaxAppender$$1.batchSizeDefault = 1;
    AjaxAppender$$1.timerIntervalDefault = 0;
    AjaxAppender$$1.thresholdDefault = "WARN";
    return AjaxAppender$$1;
}(Appender));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * An appender which stores the log messages in the browser's local storage.
 *
 * The messages are saved JSON-serialized.
 * You have to configure which key is used for storing the messages.
 *
 * A typical configuration could be:
 *
 * ```json
 * {
 *   "localStorageKey": "myLogs",
 *   "maxMessages": 500,
 *   "threshold": "INFO"
 * }
 * ```
 */
var LocalStorageAppender = /** @class */ (function (_super) {
    __extends(LocalStorageAppender, _super);
    /**
     * Creates a new instance of the appender.
     * @param configuration configuration for the appender.
     */
    function LocalStorageAppender(configuration) {
        var e_1, _a;
        var _this = _super.call(this) || this;
        if (!configuration) {
            throw new Error("configuration must be not empty");
        }
        // tslint:disable-next-line:no-null-keyword
        if (!configuration.localStorageKey || configuration.localStorageKey === "") {
            throw new Error("localStorageKey must be not empty");
        }
        _this.localStorageKey = configuration.localStorageKey;
        // read existing logMessages
        // tslint:disable-next-line:no-null-keyword
        if (localStorage.getItem(_this.localStorageKey) === null) {
            _this.logMessages = [];
        }
        else {
            _this.logMessages = JSON.parse(localStorage.getItem(_this.localStorageKey));
            try {
                for (var _b = __values(_this.logMessages), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var logMessage = _c.value;
                    // timestamps are serialized as strings
                    logMessage.timeStamp = new Date(logMessage.timeStamp);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        // process remaining configuration
        _this.configure({
            localStorageKey: configuration.localStorageKey,
            maxMessages: configuration.maxMessages || LocalStorageAppender.maxMessagesDefault,
            threshold: configuration.threshold || LocalStorageAppender.thresholdDefault,
        });
        return _this;
    }
    /**
     * Configures the logging depending on the given configuration.
     *
     * Only the defined properties get overwritten.
     * The localStorageKey cannot be modified.
     *
     * @param configuration configuration data.
     */
    /**
     * Configures the logging depending on the given configuration.
     *
     * Only the defined properties get overwritten.
     * The localStorageKey cannot be modified.
     *
     * @param {?} configuration configuration data.
     * @return {?}
     */
    LocalStorageAppender.prototype.configure = /**
     * Configures the logging depending on the given configuration.
     *
     * Only the defined properties get overwritten.
     * The localStorageKey cannot be modified.
     *
     * @param {?} configuration configuration data.
     * @return {?}
     */
    function (configuration) {
        if (configuration) {
            if (configuration.localStorageKey && configuration.localStorageKey !== this.localStorageKey) {
                throw new Error("localStorageKey must not be changed");
            }
            if (configuration.maxMessages) {
                this.setMaxMessages(configuration.maxMessages);
            }
            if (configuration.threshold) {
                /** @type {?} */
                var convertedThreshold = LogLevelConverter.levelToLog4Javascript(LogLevelConverter.levelFromString(configuration.threshold));
                this.setThreshold(convertedThreshold);
            }
        }
    };
    /**
     * Appender-specific method to append a log message.
     * @param loggingEvent event to be appended.
     */
    /**
     * Appender-specific method to append a log message.
     * @param {?} loggingEvent event to be appended.
     * @return {?}
     */
    LocalStorageAppender.prototype.append = /**
     * Appender-specific method to append a log message.
     * @param {?} loggingEvent event to be appended.
     * @return {?}
     */
    function (loggingEvent) {
        // if logMessages is already full, remove oldest element
        while (this.logMessages.length >= this.maxMessages) {
            this.logMessages.shift();
        }
        // add event to logMessages
        /** @type {?} */
        var message = {
            level: LogLevel[LogLevelConverter.levelFromLog4Javascript(loggingEvent.level)],
            logger: typeof loggingEvent.logger !== "undefined" ? loggingEvent.logger.name : undefined,
            message: loggingEvent.messages.slice(1),
            methodName: loggingEvent.messages[0],
            timeStamp: loggingEvent.timeStamp,
        };
        this.logMessages.push(message);
        // write values to localStorage
        localStorage.setItem(this.localStorageKey, JSON.stringify(this.logMessages));
    };
    /**
     * Gets the appender's name.
     * Mainly for unit testing purposes.
     * @return appender's name
     */
    /**
     * Gets the appender's name.
     * Mainly for unit testing purposes.
     * @return {?} appender's name
     */
    LocalStorageAppender.prototype.toString = /**
     * Gets the appender's name.
     * Mainly for unit testing purposes.
     * @return {?} appender's name
     */
    function () {
        return "Ionic.Logging.LocalStorageAppender";
    };
    /**
     * Get the key which is used to store the messages in the local storage.
     */
    /**
     * Get the key which is used to store the messages in the local storage.
     * @return {?}
     */
    LocalStorageAppender.prototype.getLocalStorageKey = /**
     * Get the key which is used to store the messages in the local storage.
     * @return {?}
     */
    function () {
        return this.localStorageKey;
    };
    /**
     * Get the maximum number of messages which will be stored in local storage.
     */
    /**
     * Get the maximum number of messages which will be stored in local storage.
     * @return {?}
     */
    LocalStorageAppender.prototype.getMaxMessages = /**
     * Get the maximum number of messages which will be stored in local storage.
     * @return {?}
     */
    function () {
        return this.maxMessages;
    };
    /**
     * Set the maximum number of messages which will be stored in local storage.
     *
     * If the appender stores currently more messages than the new value allows, the oldest messages get removed.
     * @param value new maximum number
     */
    /**
     * Set the maximum number of messages which will be stored in local storage.
     *
     * If the appender stores currently more messages than the new value allows, the oldest messages get removed.
     * @param {?} value new maximum number
     * @return {?}
     */
    LocalStorageAppender.prototype.setMaxMessages = /**
     * Set the maximum number of messages which will be stored in local storage.
     *
     * If the appender stores currently more messages than the new value allows, the oldest messages get removed.
     * @param {?} value new maximum number
     * @return {?}
     */
    function (value) {
        if (this.maxMessages !== value) {
            this.maxMessages = value;
            if (this.logMessages.length > this.maxMessages) {
                // there are too much logMessages for the new value, therefore remove oldest messages
                while (this.logMessages.length > this.maxMessages) {
                    this.logMessages.shift();
                }
                // write values to localStorage
                localStorage.setItem(this.localStorageKey, JSON.stringify(this.logMessages));
            }
        }
    };
    /**
     * Gets all messages stored in local storage.
     * Mainly for unit testing purposes.
     * @return stored messages
     */
    /**
     * Gets all messages stored in local storage.
     * Mainly for unit testing purposes.
     * @return {?} stored messages
     */
    LocalStorageAppender.prototype.getLogMessages = /**
     * Gets all messages stored in local storage.
     * Mainly for unit testing purposes.
     * @return {?} stored messages
     */
    function () {
        return this.logMessages;
    };
    /**
     * Removes all messages from local storage.
     * Mainly for unit testing purposes.
     */
    /**
     * Removes all messages from local storage.
     * Mainly for unit testing purposes.
     * @return {?}
     */
    LocalStorageAppender.prototype.clearLog = /**
     * Removes all messages from local storage.
     * Mainly for unit testing purposes.
     * @return {?}
     */
    function () {
        this.logMessages = [];
        localStorage.removeItem(this.localStorageKey);
    };
    LocalStorageAppender.maxMessagesDefault = 250;
    LocalStorageAppender.thresholdDefault = "WARN";
    return LocalStorageAppender;
}(Appender));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Logger for writing log messages.
 */
var  /**
 * Logger for writing log messages.
 */
Logger = /** @class */ (function () {
    /**
     * Creates a new instance of a logger.
     */
    function Logger(logger) {
        if (typeof logger === "undefined") {
            this.logger = getRootLogger();
        }
        else if (typeof logger === "string") {
            this.logger = getLogger(logger);
        }
        else {
            this.logger = logger;
        }
    }
    /**
     * Get the log level.
     */
    /**
     * Get the log level.
     * @return {?}
     */
    Logger.prototype.getLogLevel = /**
     * Get the log level.
     * @return {?}
     */
    function () {
        return LogLevelConverter.levelFromLog4Javascript(this.logger.getLevel());
    };
    /**
     * Set the log level.
     *
     * @param level the new log level
     */
    /**
     * Set the log level.
     *
     * @param {?} level the new log level
     * @return {?}
     */
    Logger.prototype.setLogLevel = /**
     * Set the log level.
     *
     * @param {?} level the new log level
     * @return {?}
     */
    function (level) {
        this.logger.setLevel(LogLevelConverter.levelToLog4Javascript(level));
    };
    /**
     * Logs a message at level TRACE.
     *
     * @param methodName name of the method
     * @param params optional parameters to be logged; objects will be formatted as JSON
     */
    /**
     * Logs a message at level TRACE.
     *
     * @param {?} methodName name of the method
     * @param {...?} params optional parameters to be logged; objects will be formatted as JSON
     * @return {?}
     */
    Logger.prototype.trace = /**
     * Logs a message at level TRACE.
     *
     * @param {?} methodName name of the method
     * @param {...?} params optional parameters to be logged; objects will be formatted as JSON
     * @return {?}
     */
    function (methodName) {
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        var e_1, _a;
        if (this.logger.isTraceEnabled()) {
            /** @type {?} */
            var args = [methodName];
            try {
                for (var params_1 = __values(params), params_1_1 = params_1.next(); !params_1_1.done; params_1_1 = params_1.next()) {
                    var param = params_1_1.value;
                    args.push(this.formatArgument(param));
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (params_1_1 && !params_1_1.done && (_a = params_1.return)) _a.call(params_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            this.logger.trace.apply(this.logger, args);
        }
    };
    /**
     * Logs a message at level DEBUG.
     *
     * @param methodName name of the method
     * @param params optional parameters to be logged; objects will be formatted as JSON
     */
    /**
     * Logs a message at level DEBUG.
     *
     * @param {?} methodName name of the method
     * @param {...?} params optional parameters to be logged; objects will be formatted as JSON
     * @return {?}
     */
    Logger.prototype.debug = /**
     * Logs a message at level DEBUG.
     *
     * @param {?} methodName name of the method
     * @param {...?} params optional parameters to be logged; objects will be formatted as JSON
     * @return {?}
     */
    function (methodName) {
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        var e_2, _a;
        if (this.logger.isDebugEnabled()) {
            /** @type {?} */
            var args = [methodName];
            try {
                for (var params_2 = __values(params), params_2_1 = params_2.next(); !params_2_1.done; params_2_1 = params_2.next()) {
                    var param = params_2_1.value;
                    args.push(this.formatArgument(param));
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (params_2_1 && !params_2_1.done && (_a = params_2.return)) _a.call(params_2);
                }
                finally { if (e_2) throw e_2.error; }
            }
            this.logger.debug.apply(this.logger, args);
        }
    };
    /**
     * Logs a message at level INFO.
     *
     * @param methodName name of the method
     * @param params optional parameters to be logged; objects will be formatted as JSON
     */
    /**
     * Logs a message at level INFO.
     *
     * @param {?} methodName name of the method
     * @param {...?} params optional parameters to be logged; objects will be formatted as JSON
     * @return {?}
     */
    Logger.prototype.info = /**
     * Logs a message at level INFO.
     *
     * @param {?} methodName name of the method
     * @param {...?} params optional parameters to be logged; objects will be formatted as JSON
     * @return {?}
     */
    function (methodName) {
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        var e_3, _a;
        if (this.logger.isInfoEnabled()) {
            /** @type {?} */
            var args = [methodName];
            try {
                for (var params_3 = __values(params), params_3_1 = params_3.next(); !params_3_1.done; params_3_1 = params_3.next()) {
                    var param = params_3_1.value;
                    args.push(this.formatArgument(param));
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (params_3_1 && !params_3_1.done && (_a = params_3.return)) _a.call(params_3);
                }
                finally { if (e_3) throw e_3.error; }
            }
            this.logger.info.apply(this.logger, args);
        }
    };
    /**
     * Logs a message at level WARN.
     *
     * @param methodName name of the method
     * @param params optional parameters to be logged; objects will be formatted as JSON
     */
    /**
     * Logs a message at level WARN.
     *
     * @param {?} methodName name of the method
     * @param {...?} params optional parameters to be logged; objects will be formatted as JSON
     * @return {?}
     */
    Logger.prototype.warn = /**
     * Logs a message at level WARN.
     *
     * @param {?} methodName name of the method
     * @param {...?} params optional parameters to be logged; objects will be formatted as JSON
     * @return {?}
     */
    function (methodName) {
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        var e_4, _a;
        if (this.logger.isWarnEnabled()) {
            /** @type {?} */
            var args = [methodName];
            try {
                for (var params_4 = __values(params), params_4_1 = params_4.next(); !params_4_1.done; params_4_1 = params_4.next()) {
                    var param = params_4_1.value;
                    args.push(this.formatArgument(param));
                }
            }
            catch (e_4_1) { e_4 = { error: e_4_1 }; }
            finally {
                try {
                    if (params_4_1 && !params_4_1.done && (_a = params_4.return)) _a.call(params_4);
                }
                finally { if (e_4) throw e_4.error; }
            }
            this.logger.warn.apply(this.logger, args);
        }
    };
    /**
     * Logs a message at level ERROR.
     *
     * @param methodName name of the method
     * @param params optional parameters to be logged; objects will be formatted as JSON
     */
    /**
     * Logs a message at level ERROR.
     *
     * @param {?} methodName name of the method
     * @param {...?} params optional parameters to be logged; objects will be formatted as JSON
     * @return {?}
     */
    Logger.prototype.error = /**
     * Logs a message at level ERROR.
     *
     * @param {?} methodName name of the method
     * @param {...?} params optional parameters to be logged; objects will be formatted as JSON
     * @return {?}
     */
    function (methodName) {
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        var e_5, _a;
        if (this.logger.isErrorEnabled()) {
            /** @type {?} */
            var args = [methodName];
            try {
                for (var params_5 = __values(params), params_5_1 = params_5.next(); !params_5_1.done; params_5_1 = params_5.next()) {
                    var param = params_5_1.value;
                    args.push(this.formatArgument(param));
                }
            }
            catch (e_5_1) { e_5 = { error: e_5_1 }; }
            finally {
                try {
                    if (params_5_1 && !params_5_1.done && (_a = params_5.return)) _a.call(params_5);
                }
                finally { if (e_5) throw e_5.error; }
            }
            this.logger.error.apply(this.logger, args);
        }
    };
    /**
     * Logs a message at level FATAL.
     *
     * @param methodName name of the method
     * @param params optional parameters to be logged; objects will be formatted as JSON
     */
    /**
     * Logs a message at level FATAL.
     *
     * @param {?} methodName name of the method
     * @param {...?} params optional parameters to be logged; objects will be formatted as JSON
     * @return {?}
     */
    Logger.prototype.fatal = /**
     * Logs a message at level FATAL.
     *
     * @param {?} methodName name of the method
     * @param {...?} params optional parameters to be logged; objects will be formatted as JSON
     * @return {?}
     */
    function (methodName) {
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        var e_6, _a;
        if (this.logger.isFatalEnabled()) {
            /** @type {?} */
            var args = [methodName];
            try {
                for (var params_6 = __values(params), params_6_1 = params_6.next(); !params_6_1.done; params_6_1 = params_6.next()) {
                    var param = params_6_1.value;
                    args.push(this.formatArgument(param));
                }
            }
            catch (e_6_1) { e_6 = { error: e_6_1 }; }
            finally {
                try {
                    if (params_6_1 && !params_6_1.done && (_a = params_6.return)) _a.call(params_6);
                }
                finally { if (e_6) throw e_6.error; }
            }
            this.logger.fatal.apply(this.logger, args);
        }
    };
    /**
     * Logs the entry into a method.
     * The method name will be logged at level INFO, the parameters at level DEBUG.
     *
     * @param methodName name of the method
     * @param params optional parameters to be logged; objects will be formatted as JSON
     */
    /**
     * Logs the entry into a method.
     * The method name will be logged at level INFO, the parameters at level DEBUG.
     *
     * @param {?} methodName name of the method
     * @param {...?} params optional parameters to be logged; objects will be formatted as JSON
     * @return {?}
     */
    Logger.prototype.entry = /**
     * Logs the entry into a method.
     * The method name will be logged at level INFO, the parameters at level DEBUG.
     *
     * @param {?} methodName name of the method
     * @param {...?} params optional parameters to be logged; objects will be formatted as JSON
     * @return {?}
     */
    function (methodName) {
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        var e_7, _a;
        if (this.logger.isInfoEnabled()) {
            /** @type {?} */
            var args = [methodName, "entry"];
            if (this.logger.isDebugEnabled()) {
                try {
                    for (var params_7 = __values(params), params_7_1 = params_7.next(); !params_7_1.done; params_7_1 = params_7.next()) {
                        var param = params_7_1.value;
                        args.push(this.formatArgument(param));
                    }
                }
                catch (e_7_1) { e_7 = { error: e_7_1 }; }
                finally {
                    try {
                        if (params_7_1 && !params_7_1.done && (_a = params_7.return)) _a.call(params_7);
                    }
                    finally { if (e_7) throw e_7.error; }
                }
            }
            this.logger.info.apply(this.logger, args);
        }
    };
    /**
     * Logs the exit of a method.
     * The method name will be logged at level INFO, the parameters at level DEBUG.
     *
     * @param methodName name of the method
     * @param params optional parameters to be logged; objects will be formatted as JSON
     */
    /**
     * Logs the exit of a method.
     * The method name will be logged at level INFO, the parameters at level DEBUG.
     *
     * @param {?} methodName name of the method
     * @param {...?} params optional parameters to be logged; objects will be formatted as JSON
     * @return {?}
     */
    Logger.prototype.exit = /**
     * Logs the exit of a method.
     * The method name will be logged at level INFO, the parameters at level DEBUG.
     *
     * @param {?} methodName name of the method
     * @param {...?} params optional parameters to be logged; objects will be formatted as JSON
     * @return {?}
     */
    function (methodName) {
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        var e_8, _a;
        if (this.logger.isInfoEnabled()) {
            /** @type {?} */
            var args = [methodName, "exit"];
            if (this.logger.isDebugEnabled()) {
                try {
                    for (var params_8 = __values(params), params_8_1 = params_8.next(); !params_8_1.done; params_8_1 = params_8.next()) {
                        var param = params_8_1.value;
                        args.push(this.formatArgument(param));
                    }
                }
                catch (e_8_1) { e_8 = { error: e_8_1 }; }
                finally {
                    try {
                        if (params_8_1 && !params_8_1.done && (_a = params_8.return)) _a.call(params_8);
                    }
                    finally { if (e_8) throw e_8.error; }
                }
            }
            this.logger.info.apply(this.logger, args);
        }
    };
    /**
     * Formats the given argument.
     */
    /**
     * Formats the given argument.
     * @param {?} arg
     * @return {?}
     */
    Logger.prototype.formatArgument = /**
     * Formats the given argument.
     * @param {?} arg
     * @return {?}
     */
    function (arg) {
        if (typeof arg === "string") {
            return arg;
        }
        else if (typeof arg === "number") {
            return arg.toString();
        }
        else if (arg instanceof Error) {
            // JSON.stringify() returns here "{ }"
            return arg.toString();
        }
        else {
            try {
                return JSON.stringify(arg);
            }
            catch (e) {
                return e.message;
            }
        }
    };
    /**
     * Returns the internal Logger (for unit tests only).
     */
    /**
     * Returns the internal Logger (for unit tests only).
     * @return {?}
     */
    Logger.prototype.getInternalLogger = /**
     * Returns the internal Logger (for unit tests only).
     * @return {?}
     */
    function () {
        return this.logger;
    };
    return Logger;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * An appender which stores the log messages in the browser's memory.
 *
 * The MemoryAppender is enabled by default.
 * If you do not specify anything else, it is using this configuration:
 *
 * ```JSON
 * {
 *   "memoryAppender": [
 *     {
 *       "maxMessages": 250,
 *       "threshold": "ALL"
 *     }
 * }
 * ```
 */
var MemoryAppender = /** @class */ (function (_super) {
    __extends(MemoryAppender, _super);
    /**
     * Creates a new instance of the appender.
     * @param configuration configuration for the appender.
     */
    function MemoryAppender(configuration) {
        var _this = _super.call(this) || this;
        _this.logMessages = [];
        // process configuration
        configuration = configuration || {};
        _this.configure({
            maxMessages: configuration.maxMessages || MemoryAppender.maxMessagesDefault,
            threshold: configuration.threshold || MemoryAppender.thresholdDefault,
        });
        _this.maxMessages = MemoryAppender.maxMessagesDefault;
        return _this;
    }
    /**
     * Configures the logging depending on the given configuration.
     * Only the defined properties get overwritten.
     *
     * @param configuration configuration data.
     */
    /**
     * Configures the logging depending on the given configuration.
     * Only the defined properties get overwritten.
     *
     * @param {?} configuration configuration data.
     * @return {?}
     */
    MemoryAppender.prototype.configure = /**
     * Configures the logging depending on the given configuration.
     * Only the defined properties get overwritten.
     *
     * @param {?} configuration configuration data.
     * @return {?}
     */
    function (configuration) {
        if (configuration) {
            if (configuration.maxMessages) {
                this.setMaxMessages(configuration.maxMessages);
            }
            if (configuration.threshold) {
                /** @type {?} */
                var convertedThreshold = LogLevelConverter.levelToLog4Javascript(LogLevelConverter.levelFromString(configuration.threshold));
                this.setThreshold(convertedThreshold);
            }
        }
    };
    /**
     * Appender-specific method to append a log message.
     * @param loggingEvent event to be appended.
     */
    /**
     * Appender-specific method to append a log message.
     * @param {?} loggingEvent event to be appended.
     * @return {?}
     */
    MemoryAppender.prototype.append = /**
     * Appender-specific method to append a log message.
     * @param {?} loggingEvent event to be appended.
     * @return {?}
     */
    function (loggingEvent) {
        // if logMessages is already full, remove oldest element
        while (this.logMessages.length >= this.maxMessages) {
            this.logMessages.shift();
        }
        // add event to logMessages
        /** @type {?} */
        var message = {
            level: LogLevel[LogLevelConverter.levelFromLog4Javascript(loggingEvent.level)],
            logger: typeof loggingEvent.logger === "object" ? loggingEvent.logger.name : undefined,
            message: loggingEvent.messages.slice(1),
            methodName: loggingEvent.messages[0],
            timeStamp: loggingEvent.timeStamp,
        };
        this.logMessages.push(message);
        // inform about new message
        if (typeof this.onLogMessagesChangedCallback === "function") {
            this.onLogMessagesChangedCallback(message);
        }
    };
    /**
     * Gets the appender's name.
     * Mainly for unit testing purposes.
     * @return appender's name
     */
    /**
     * Gets the appender's name.
     * Mainly for unit testing purposes.
     * @return {?} appender's name
     */
    MemoryAppender.prototype.toString = /**
     * Gets the appender's name.
     * Mainly for unit testing purposes.
     * @return {?} appender's name
     */
    function () {
        return "Ionic.Logging.MemoryAppender";
    };
    /**
     * Get the maximum number of messages which will be stored in memory.
     */
    /**
     * Get the maximum number of messages which will be stored in memory.
     * @return {?}
     */
    MemoryAppender.prototype.getMaxMessages = /**
     * Get the maximum number of messages which will be stored in memory.
     * @return {?}
     */
    function () {
        return this.maxMessages;
    };
    /**
     * Set the maximum number of messages which will be stored in memory.
     *
     * If the appender stores currently more messages than the new value allows, the oldest messages get removed.
     * @param value new maximum number
     */
    /**
     * Set the maximum number of messages which will be stored in memory.
     *
     * If the appender stores currently more messages than the new value allows, the oldest messages get removed.
     * @param {?} value new maximum number
     * @return {?}
     */
    MemoryAppender.prototype.setMaxMessages = /**
     * Set the maximum number of messages which will be stored in memory.
     *
     * If the appender stores currently more messages than the new value allows, the oldest messages get removed.
     * @param {?} value new maximum number
     * @return {?}
     */
    function (value) {
        this.maxMessages = value;
        // if there are too much logMessages for the new value, remove oldest messages
        if (this.logMessages.length > this.maxMessages) {
            this.logMessages.splice(0, this.logMessages.length - this.maxMessages);
        }
    };
    /**
     * Gets all messages stored in memory.
     * @return stored messages
     */
    /**
     * Gets all messages stored in memory.
     * @return {?} stored messages
     */
    MemoryAppender.prototype.getLogMessages = /**
     * Gets all messages stored in memory.
     * @return {?} stored messages
     */
    function () {
        return this.logMessages;
    };
    /**
     * Registers a callback which will be called every time a new message is appended.
     * This could be useful if you want to show new messages in realtime.
     * @param callback callback to be called
     */
    /**
     * Registers a callback which will be called every time a new message is appended.
     * This could be useful if you want to show new messages in realtime.
     * @param {?} callback callback to be called
     * @return {?}
     */
    MemoryAppender.prototype.setOnLogMessagesChangedCallback = /**
     * Registers a callback which will be called every time a new message is appended.
     * This could be useful if you want to show new messages in realtime.
     * @param {?} callback callback to be called
     * @return {?}
     */
    function (callback) {
        this.onLogMessagesChangedCallback = callback;
    };
    MemoryAppender.maxMessagesDefault = 250;
    MemoryAppender.thresholdDefault = "ALL";
    return MemoryAppender;
}(Appender));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Service for logging functionality.
 *
 * By default, the following settings are used:
 *  - logger: root with level WARN
 *  - appender: BrowserConsoleAppender with threshold DEBUG and MemoryAppender with threshold ALL
 *
 * Via [configure](#configure), it is possible to amend these settings.
 */
var LoggingService = /** @class */ (function () {
    /**
     * Creates a new instance of the service.
     */
    function LoggingService() {
        var _this = this;
        // prevent log4javascript to show alerts on case of errors
        logLog.setQuietMode(true);
        // create event emitter
        this.logMessagesChanged = new EventEmitter();
        this.ajaxAppenderFailed = new EventEmitter();
        // configure appender
        /** @type {?} */
        var logger = getRootLogger();
        logger.setLevel(Level.WARN);
        // browser console appender for debugger
        this.browserConsoleAppender = new BrowserConsoleAppender();
        this.browserConsoleAppender.setLayout(new PatternLayout("%d{HH:mm:ss,SSS} %c %m"));
        this.browserConsoleAppender.setThreshold(Level.ALL);
        logger.addAppender(this.browserConsoleAppender);
        // in-memory appender for display on log messages page
        this.memoryAppender = new MemoryAppender();
        this.memoryAppender.setLayout(new PatternLayout("%d{HH:mm:ss,SSS} %c %m"));
        this.memoryAppender.setOnLogMessagesChangedCallback(function (message) {
            _this.logMessagesChanged.emit(message);
        });
        logger.addAppender(this.memoryAppender);
        this.configure();
    }
    /**
     * Configures the logging depending on the given configuration.
     * @param configuration configuration data.
     */
    /**
     * Configures the logging depending on the given configuration.
     * @param {?=} configuration configuration data.
     * @return {?}
     */
    LoggingService.prototype.configure = /**
     * Configures the logging depending on the given configuration.
     * @param {?=} configuration configuration data.
     * @return {?}
     */
    function (configuration) {
        var _this = this;
        var e_1, _a;
        if (typeof configuration === "undefined") {
            configuration = {};
        }
        // set log levels
        if (typeof configuration.logLevels !== "undefined") {
            try {
                for (var _b = __values(configuration.logLevels), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var level = _c.value;
                    /** @type {?} */
                    var logger = void 0;
                    if (level.loggerName === "root") {
                        logger = getRootLogger();
                    }
                    else {
                        logger = getLogger(level.loggerName);
                    }
                    try {
                        logger.setLevel(LogLevelConverter.levelToLog4Javascript(LogLevelConverter.levelFromString(level.logLevel)));
                    }
                    catch (e) {
                        throw new Error("invalid log level " + level.logLevel);
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        // configure AjaxAppender
        if (typeof configuration.ajaxAppender !== "undefined") {
            /** @type {?} */
            var ajaxAppender = new AjaxAppender$1(configuration.ajaxAppender);
            ajaxAppender.appenderFailed.subscribe(function (message) {
                _this.ajaxAppenderFailed.emit(message);
            });
            getRootLogger().addAppender(ajaxAppender);
        }
        // configure LocalStorageAppender
        if (typeof configuration.localStorageAppender !== "undefined") {
            /** @type {?} */
            var localStorageAppender = new LocalStorageAppender(configuration.localStorageAppender);
            getRootLogger().addAppender(localStorageAppender);
        }
        // configure MemoryAppender
        if (configuration.memoryAppender) {
            this.memoryAppender.configure(configuration.memoryAppender);
        }
        // configure BrowserConsoleAppender
        if (configuration.browserConsoleAppender) {
            if (configuration.browserConsoleAppender.threshold) {
                /** @type {?} */
                var convertedThreshold = LogLevelConverter.levelToLog4Javascript(LogLevelConverter.levelFromString(configuration.browserConsoleAppender.threshold));
                this.browserConsoleAppender.setThreshold(convertedThreshold);
            }
        }
    };
    /**
     * Gets the root logger from which all other loggers derive.
     * @return root logger
     */
    /**
     * Gets the root logger from which all other loggers derive.
     * @return {?} root logger
     */
    LoggingService.prototype.getRootLogger = /**
     * Gets the root logger from which all other loggers derive.
     * @return {?} root logger
     */
    function () {
        return new Logger();
    };
    /**
     * Gets a logger with the specified name, creating it if a logger with that name does not already exist.
     * @param loggerName name of the logger
     * @return logger
     */
    /**
     * Gets a logger with the specified name, creating it if a logger with that name does not already exist.
     * @param {?} loggerName name of the logger
     * @return {?} logger
     */
    LoggingService.prototype.getLogger = /**
     * Gets a logger with the specified name, creating it if a logger with that name does not already exist.
     * @param {?} loggerName name of the logger
     * @return {?} logger
     */
    function (loggerName) {
        return new Logger(loggerName);
    };
    /**
     * Gets the last log messages.
     *
     * The log messages are retrieved from the internal [MemoryAppender](../memoryappender.html).
     * That means you will get only the most current messages. The number of the messages is limited
     * by its maxMessages value.
     * @return log messages
     */
    /**
     * Gets the last log messages.
     *
     * The log messages are retrieved from the internal [MemoryAppender](../memoryappender.html).
     * That means you will get only the most current messages. The number of the messages is limited
     * by its maxMessages value.
     * @return {?} log messages
     */
    LoggingService.prototype.getLogMessages = /**
     * Gets the last log messages.
     *
     * The log messages are retrieved from the internal [MemoryAppender](../memoryappender.html).
     * That means you will get only the most current messages. The number of the messages is limited
     * by its maxMessages value.
     * @return {?} log messages
     */
    function () {
        return this.memoryAppender.getLogMessages();
    };
    LoggingService.decorators = [
        { type: Injectable, args: [{
                    providedIn: "root"
                },] }
    ];
    /** @nocollapse */
    LoggingService.ctorParameters = function () { return []; };
    /** @nocollapse */ LoggingService.ngInjectableDef = defineInjectable({ factory: function LoggingService_Factory() { return new LoggingService(); }, token: LoggingService, providedIn: "root" });
    return LoggingService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LoggingServiceModule = /** @class */ (function () {
    function LoggingServiceModule() {
    }
    LoggingServiceModule.decorators = [
        { type: NgModule, args: [{
                    imports: [],
                    declarations: [],
                    exports: []
                },] }
    ];
    return LoggingServiceModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { AjaxAppender$1 as AjaxAppender, LocalStorageAppender, LogLevelConverter, LogLevel, Logger, LoggingService, LoggingServiceModule, MemoryAppender };

//# sourceMappingURL=ionic-logging-service.js.map